<div class="video-container">
  <video id="video-background" autoplay muted loop playsinline>
    <source [src]="videoPath" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
  <div class="overlay">
    <div class="content">
      <h1>{{ title }}</h1>
      <p>{{ description }}</p>
    </div>
  </div>
</div>

  <!-- <script>
    // Load the IFrame Player API code asynchronously
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // Create YouTube player
    var player;
    function onYouTubeIframeAPIReady() {
      player = new YT.Player('player', {
        videoId: '-yLhDDGoYc4', // Replace with your YouTube video ID
        playerVars: {
          'autoplay': 1,
          'controls': 0,
          'showinfo': 0,
          'modestbranding': 1,
          'loop': 1,
          'mute': 1,
          'playlist': '-yLhDDGoYc4', // Replace with the same video ID for looping
          'rel': 0
        },
        events: {
          'onStateChange': onPlayerStateChange
        }
      });
    }

    // This function runs when the player's state changes
    function onPlayerStateChange(event) {
      if (event.data == YT.PlayerState.PLAYING) {
        checkBuffer();      
      }

      function checkBuffer() {
        var checkDownloadInterval = setInterval(function() {
        var videoDuration = player.getDuration(); // Durasi total video
        var loadedFraction = player.getVideoLoadedFraction(); // Fraksi yang telah diunduh
        var bufferedTime = loadedFraction * videoDuration; // Waktu yang telah diunduh dalam detik

        if (bufferedTime >= 15) { // Cek apakah waktu yang diunduh sudah 15 detik
            // Tambahkan kelas CSS setelah video telah diunduh minimal 15 detik
            document.getElementById('video-background').classList.add('video-loaded');
            document.getElementById('player').classList.add('pp');
            clearInterval(checkDownloadInterval); // Hentikan interval setelah cukup
        }
    }, 100); // Cek setiap 100 ms
    }
  }
  </script> -->

